/**
 * Validates if the given input is an array.
 * Throws an error with a custom message if the validation fails.
 *
 * @param input - The input to validate.
 * @param errorMessage - Custom error message to throw if validation fails.
 */
export const validateArrayInput = (input: any, errorMessage: string = "Input must be an array."): void => {
    if (!Array.isArray(input)) {
        throw new Error(errorMessage);
    }
};